/**
 * Superadmin layout (isolated admin panel).
 * Sidebar + main content. Used for all authenticated /dashboard, /users, etc.
 */
import { Link, Outlet, useLocation } from '@tanstack/react-router';
import { ImpersonateBanner } from '../components/ImpersonateBanner.js';

const ADMIN_NAV_ITEMS = [
  { path: '/dashboard', label: 'ダッシュボード', icon: '■' },
  { path: '/users', label: 'ユーザー管理', icon: '■' },
  { path: '/sites', label: 'サイト管理', icon: '■' },
  { path: '/billing', label: '課金管理', icon: '■' },
  { path: '/audit-logs', label: '監査ログ', icon: '■' },
] as const;

export function AdminLayout() {
  const location = useLocation();

  return (
    <>
      <ImpersonateBanner />
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        {/* Sidebar */}
        <aside
          style={{
            width: 240,
            backgroundColor: '#1e293b',
            color: '#e2e8f0',
            padding: '16px 0',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div style={{ padding: '0 16px 16px', borderBottom: '1px solid #334155' }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, margin: 0 }}>PetaCMS Admin</h2>
            <span style={{ fontSize: 12, color: '#94a3b8' }}>運営管理</span>
          </div>
          <nav style={{ flex: 1, padding: '8px 0' }}>
            {ADMIN_NAV_ITEMS.map((item) => {
              const isActive = location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  style={{
                    display: 'block',
                    padding: '10px 16px',
                    color: isActive ? '#fff' : '#cbd5e1',
                    backgroundColor: isActive ? '#334155' : 'transparent',
                    textDecoration: 'none',
                    fontSize: 14,
                    borderLeft: isActive ? '3px solid #3b82f6' : '3px solid transparent',
                  }}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </aside>

        {/* Main content */}
        <main style={{ flex: 1, backgroundColor: '#f8fafc', padding: 24 }}>
          <Outlet />
        </main>
      </div>
    </>
  );
}
